// A planner child or a fully loaded PageExperience.
type TitledLayout = {
  title?: string | null;
};

/**
 * The title a rendered header shows: a view's own, falling back to the owning
 * planner's until the author sets one. It never names the view — the pickers
 * derive that from layoutId and kind (lib/viewName).
 *
 * Any non-empty title is the author's. Views created before server#1735 still
 * carry a name stamped at creation and so read as authored; accepted, because
 * the alternative was a hand-copied list of seeded names that drifted and
 * overrode authors who typed one of them themselves.
 */
export const resolveHeaderTitle = (
  experience: TitledLayout,
  parentExperience?: { title: string }
): string => experience.title?.trim() || parentExperience?.title || '';
